import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'app-consent-otp',
  templateUrl: './otp.component.html',
  styleUrls: ['./otp.component.css', '../../../../assets/styles/form-styles.css']
})
export class OtpComponent implements OnInit {
  isVerified: boolean;
  isOtpRequested: boolean;
  otp: string;

  @Input()
  editDisabled: boolean;
  @Input()
  maxlength: number;
  @Input()
  inputValue: string;

  @Output()
  otpRequest = new EventEmitter<string>();
  @Output()
  otpEntered = new EventEmitter<string>();

  ngOnInit(): void {
    this.isOtpRequested = false;
  }

  onOtpRequest() {
    this.isOtpRequested = true;
    this.otpRequest.emit(this.inputValue);
  }

  notifyFormSubmission() {
  }

  canEnableButton() {
    this.otpEntered.emit(this.otp);
  }
}
